<template>
  <div class="modal fade !p-0" id="cancelClaimModal" ref="cModal" tabindex="-1" aria-labelledby="cancelClaimModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered tablet:w-[450px]">
      <div class="modal-content !rounded-[10px] border-0 shadow-lg font-poppins">
        <div class="modal-body !p-[10px]">
          <div class="relative h-[80px] bg-customBlue-100 rounded-[10px]">
            <button type="button" @click="hide"
              class="absolute top-3 right-4 z-50 focus:!outline-none focus:!shadow-none bg-transparent border-0"
              aria-label="Close">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon" class="w-[30px] h-[30px]">
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <div class="relative flex justify-between items-center w-full z-10 ps-6 !pe-12">
                <h6 class="m-0 text-[20px] font-poppins font-semibold text-white tracking-wider">
                  Cancel Claim
                </h6>
              </div>
            </div>
          </div>
          <div class="p-[20px] min-h-[150px]">
            <p class="text-[#666666] mb-[10px] text-[16px] font-poppins font-normal">Please select a reason for
              cancelling your claim:</p>
            <singleSelectDropdown :options="formattedReasons" optionKey="name" selectValueKey="name" fieldName="reason"
              :updateOption="updateReason" :selectedOptions="selectedReason" placeholder="Select Reason" class="mb-0"
              inputClass="p-2.5 px-[10px] rounded-[5px] w-full border text-left border-customGray focus:outline-none text-[16px] font-poppins" />
            <div v-if="selectedReason === 'Other'" class="mt-4">
              <inputComponent ref="otherReasonInput" v-model="otherReason" label="Other Reason"
                labelClass="!text-[16px] !font-poppins !text-[#666666] !font-normal !mb-[10px]"
                placeholder="Enter your reason here" :required="true" name="other_reason"
                customClass="!p-2.5 !text-[16px] !font-poppins placeholder:!text-[#999]" />
            </div>
            <div class="mt-[20px] flex flex-row justify-center gap-3">
              <button @click="hide"
                class="hidden w-auto px-6 py-2 rounded-full text-[16px] font-normal transition-all CustomYellowBtn !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100">
                Dismiss
              </button>
              <button @click="handleCancel"
                class="CustomYellowBtn w-auto px-6 py-2 rounded-full text-[16px] font-normal transition-all disabled:bg-[#EFEFEF] disabled:hover:bg-gradient-to-r disabled:hover:from-[#EFEFEF] disabled:hover:to-[#EFEFEF] disabled:hover:!text-[#999999] disabled:cursor-not-allowed disabled:!text-[#999999] disabled:!border-[#EFEFEF] "
                :disabled="!selectedReason || (selectedReason === 'Other' && !otherReason.trim())">
                Cancel Claim
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import inputComponent from '../partialComponent/inputComponent.vue';
import singleSelectDropdown from '../partialComponent/singleSelectDropdown.vue';
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from 'bootstrap';

export default {
  name: 'CancelClaimModal',
  components: {
    inputComponent,
    singleSelectDropdown
  },
  data() {
    return {
      modal: null,
      appointmentId: null,
      selectedReason: '',
      otherReason: ''
    };
  },

  watch: {
    cancelClaimResponse: function (data) {
      this.$emit('cancelled');
      this.hide();
    },

  },
  computed: {
    ...mapGetters(['cancelClaimReasons', 'cancelClaimResponse']),
    formattedReasons() {
      if (!this.cancelClaimReasons) return [];
      return this.cancelClaimReasons.map(reason => {
        if (typeof reason === 'string') {
          return { name: reason };
        }
        return reason;
      });
    }
  },
  methods: {
    ...mapActions(['getCancelReasons', 'cancelClaim']),
    updateReason(field, value) {
      this.selectedReason = value || '';
    },

    async show(appointmentId) {
      this.appointmentId = appointmentId;
      this.selectedReason = '';
      this.otherReason = '';

      // Fetch reasons first
      await this.getCancelReasons();

      // Initialize and show modal
      if (!this.modal) {
        this.modal = new Modal(this.$refs.cModal);
      }
      this.modal.show();
      disableScroll();
    },

    hide() {
      if (this.modal) {
        this.modal.hide();
      }
      enableScroll();
    },

    async handleCancel() {
      if (this.selectedReason === 'Other') {
        if (this.$refs.otherReasonInput && !this.$refs.otherReasonInput.validate()) {
          if (this.$refs.otherReasonInput.hasError()) {
            return;
          }
        }
        if (!this.otherReason.trim()) {
          alert("hi 2")
          return;
        }
      }

      const reason = this.selectedReason == 'Other' ? this.otherReason : this.selectedReason;

      await this.cancelClaim({
        appointment_id: this.appointmentId,
        cancel_reason: reason
      });
    }
  }
};
</script>
